import React from 'react'
import './style.scss'

export default function Button({ disabled, text, onClick, className = 'primary' }) { 
    return ( 
        <button disabled={disabled} className={`btn ${className}`} onClick={() => onClick()}> 
            {text}
        </button>
    )
}